import React, { useState } from 'react';
import { PlusIcon, MapPinIcon, EditIcon, TrashIcon, CheckIcon } from 'lucide-react';
import { LocationModal } from '../modals/LocationModal';
export function AddressesSection() {
  const [addresses, setAddresses] = useState([{
    id: 1,
    label: 'Home',
    name: 'Ahmed Mohammed',
    phone: '+966 50 123 4567',
    city: 'Riyadh',
    district: 'Al Olaya',
    street: 'King Fahd Road, Building 123',
    additionalDetails: 'Apartment 4B',
    nationalAddressId: '1234-5678-9012',
    isDefault: true
  }, {
    id: 2,
    label: 'Work',
    name: 'Ahmed Mohammed',
    phone: '+966 50 123 4567',
    city: 'Riyadh',
    district: 'Al Malqa',
    street: 'Prince Turki Street, Tower 5',
    additionalDetails: 'Office 302',
    nationalAddressId: '',
    isDefault: false
  }]);
  const [locationModalOpen, setLocationModalOpen] = useState(false);
  const [editingAddress, setEditingAddress] = useState(null);
  const handleAddAddress = () => {
    setEditingAddress(null);
    setLocationModalOpen(true);
  };
  const handleEditAddress = address => {
    setEditingAddress(address);
    setLocationModalOpen(true);
  };
  const handleDeleteAddress = id => {
    if (window.confirm('Are you sure you want to delete this address?')) {
      setAddresses(addresses.filter(addr => addr.id !== id));
    }
  };
  const handleSetDefault = id => {
    setAddresses(addresses.map(addr => ({
      ...addr,
      isDefault: addr.id === id
    })));
  };
  const handleLocationSelect = location => {
    if (editingAddress) {
      // Update existing address
      setAddresses(addresses.map(addr => addr.id === editingAddress.id ? {
        ...addr,
        ...location
      } : addr));
    } else {
      // Add new address
      const newAddress = {
        id: addresses.length + 1,
        label: 'New Address',
        name: 'Ahmed Mohammed',
        phone: '+966 50 123 4567',
        ...location,
        isDefault: false
      };
      setAddresses([...addresses, newAddress]);
    }
    setLocationModalOpen(false);
    setEditingAddress(null);
  };
  return <div className="space-y-6" data-id="element-193" data-mp="1s1p8vz8ipzgc">
      <div className="flex items-center justify-between" data-id="element-194" data-mp="1x2mpi7dvqlfq">
        <h2 className="text-xl font-bold text-gray-900" data-id="element-195" data-mp="1x23hbie17bew">My Addresses</h2>
        <button onClick={handleAddAddress} className="flex items-center gap-2 px-4 py-2 bg-[#1E2B55] text-white text-sm font-medium rounded-lg hover:bg-[#162041] transition-colors" data-id="element-196" data-mp="10dx8eja2twut">
          <PlusIcon className="w-4 h-4" data-id="element-197" data-mp="19br3xs00omgx" />
          Add Address
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-198" data-mp="1e4sk03byms23">
        {addresses.map(address => <div key={address.id} className="bg-white rounded-xl border-2 border-gray-200 shadow-sm hover:shadow-md transition-all p-6" data-id="element-199" data-mp="gnv5ahqw0khi">
            <div className="flex items-start justify-between mb-4" data-id="element-200" data-mp="e4gqb21d7ti9">
              <div className="flex items-center gap-3" data-id="element-201" data-mp="9544mkm8csh9">
                <div className="w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center flex-shrink-0" data-id="element-202" data-mp="96f4488n7e2k">
                  <MapPinIcon className="w-6 h-6 text-[#1E2B55]" data-id="element-203" data-mp="447rdgfzntz6" />
                </div>
                <div data-id="element-204" data-mp="3w55z7z9lll">
                  <div className="flex items-center gap-2 mb-1" data-id="element-205" data-mp="6igm9xzol93">
                    <h3 className="font-bold text-gray-900 text-lg" data-id="element-206" data-mp="3rbifubt46oby">
                      {address.label}
                    </h3>
                    {address.isDefault && <span className="inline-flex items-center gap-1 rounded-full bg-sage-light px-2 py-0.5 text-xs font-medium text-sage-dark" data-id="element-207" data-mp="3hk5qbqusga93">
                        <CheckIcon className="h-3 w-3" data-id="element-208" data-mp="3cjrfk11sym7d" />
                        Default
                      </span>}
                  </div>
                  <p className="text-sm text-gray-600" data-id="element-209" data-mp="33m7dipw48lvp">{address.name}</p>
                </div>
              </div>
              <div className="flex items-center gap-2" data-id="element-210" data-mp="17jb1p9wijp0k">
                <button onClick={() => handleEditAddress(address)} className="p-2 text-[#1E2B55] hover:bg-blue-50 rounded-lg transition-colors" title="Edit" data-id="element-211" data-mp="1bjd27fqiice9">
                  <EditIcon className="w-5 h-5" data-id="element-212" data-mp="12q9jot10f9cr" />
                </button>
                <button onClick={() => handleDeleteAddress(address.id)} className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors" title="Delete" data-id="element-213" data-mp="ntis35xkv1xp">
                  <TrashIcon className="w-5 h-5" data-id="element-214" data-mp="eunhlhni35ol" />
                </button>
              </div>
            </div>
            <div className="grid grid-cols-1 gap-3 mb-4" data-id="element-215" data-mp="jsp3098efh38">
              <div data-id="element-216" data-mp="2973nghcdwhsx">
                <p className="text-xs text-gray-500 mb-1" data-id="element-217" data-mp="298oj6aafq6sd">Phone</p>
                <p className="text-sm font-medium text-gray-900" data-id="element-218" data-mp="2e6zs8iswod9j">
                  {address.phone}
                </p>
              </div>
              <div data-id="element-219" data-mp="2oawntot9itw5">
                <p className="text-xs text-gray-500 mb-1" data-id="element-220" data-mp="2o8ahttm0smg1">City</p>
                <p className="text-sm font-medium text-gray-900" data-id="element-221" data-mp="2jcd3tty8bs6f">
                  {address.city}
                </p>
              </div>
              <div data-id="element-222" data-mp="2x4t4wp7klg4p">
                <p className="text-xs text-gray-500 mb-1" data-id="element-223" data-mp="2sc8gy4bchx93">District</p>
                <p className="text-sm font-medium text-gray-900" data-id="element-224" data-mp="2s9vpn0jp6ajd">
                  {address.district}
                </p>
              </div>
              <div data-id="element-225" data-mp="322b8s16qd55u">
                <p className="text-xs text-gray-500 mb-1" data-id="element-226" data-mp="320qemcobvo8i">Street Address</p>
                <p className="text-sm font-medium text-gray-900" data-id="element-227" data-mp="3g22t0jnubhsa">
                  {address.street}
                </p>
              </div>
              {address.additionalDetails && <div data-id="element-228" data-mp="1ln9xekmyir0c">
                  <p className="text-xs text-gray-500 mb-1" data-id="element-229" data-mp="1lmrvb7dm5iki">
                    Additional Details
                  </p>
                  <p className="text-sm font-medium text-gray-900" data-id="element-230" data-mp="1hn9hevk7m7r6">
                    {address.additionalDetails}
                  </p>
                </div>}
              {address.nationalAddressId && <div data-id="element-231" data-mp="3lrvoykbqn1vt">
                  <p className="text-xs text-gray-500 mb-1" data-id="element-232" data-mp="3qovvewci26ng">
                    National Address ID
                  </p>
                  <p className="text-sm font-medium text-gray-900" data-id="element-233" data-mp="3vo8ssb0zyw4a">
                    {address.nationalAddressId}
                  </p>
                </div>}
            </div>
            {!address.isDefault && <button onClick={() => handleSetDefault(address.id)} className="text-sm font-medium text-[#1E2B55] hover:underline" data-id="element-234" data-mp="8hojolx92hj2">
                Set as Default Address
              </button>}
          </div>)}
      </div>
      <LocationModal isOpen={locationModalOpen} onClose={() => {
      setLocationModalOpen(false);
      setEditingAddress(null);
    }} onSelectLocation={handleLocationSelect} initialAddress={editingAddress} data-id="element-235" data-mp="n9gnc0nom74y" />
    </div>;
}